"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingCartRedesign = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const ArrowBack_1 = __importDefault(require("@mui/icons-material/ArrowBack"));
const ShoppingCart_1 = __importDefault(require("@mui/icons-material/ShoppingCart"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const useLogin_1 = __importDefault(require("../../../common/helpers/Hooks/useLogin"));
const HandoverScreen_1 = __importDefault(require("../Other/HandoverScreen"));
const ProductCatalogForm_1 = __importDefault(require("./ProductCatalogForm"));
const Menu_1 = __importDefault(require("./Menu"));
const ProductDetail_1 = __importDefault(require("./ProductDetail"));
const BookingLimitsErrorOrNotice_1 = __importDefault(require("../Booking/BookingLimitsErrorOrNotice"));
const NotificationPermissions_1 = __importDefault(require("../Notifications/NotificationPermissions"));
const ShoppingCartWrapper = styled_components_1.default.div `
    top: 0;
    left: 0;
    background: #fff;
    width: 100%;

    .booking-limits-notice {
        max-width: 600px;
        margin: 3vmin auto 0;
    }

    .product-detail{
        height:90%;
    }

    .menu-wrapper{
        height:100%;
        @media ( min-width: 600px ) {
            min-height:100%;
        }
    }

    .back-to-menu{
        display: flex;
        align-items: center;
    }
`;
const ErrorWrapper = styled_components_1.default.div `
    text-align: center;
    padding: 20px;
`;
const OrderCompletedWrapper = styled_components_1.default.div `
    color: rgba(0, 0, 0, 0.87);
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
        text-align: center;
    }
    h1 {
        font-size: 2rem;
        margin-top: 0;
    }
    a {
        margin-top: 15px;
        color: ${(props) => props.theme.palette.primary.main};
        text-transform: uppercase;
        border: ${(props) => `1px solid ${props.theme.palette.primary.main}`};
        border-radius: 0.2rem;
        padding: 0 14px 0 14px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
const PermisisonWrapper = styled_components_1.default.div `
  position: absolute;
  bottom: 16px;
  left: 20px;
  right: 20px;
  margin: 0 auto;
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const ShoppingCartRedesign = (props) => {
    const [showMenu, setShowMenu] = (0, react_1.useState)(false);
    const [showProduct, setShowProduct] = (0, react_1.useState)(false);
    const [orderCompletedData, setOrderCompletedData] = (0, react_1.useState)(null);
    const [toast, setToast] = (0, react_1.useState)("");
    const [error, setError] = (0, react_1.useState)("");
    const [product, setProduct] = (0, react_1.useState)("");
    const [basket, setBasket] = (0, react_1.useState)([]);
    const [showProductCatalogForm, setShowProductCatalogForm] = (0, react_1.useState)(false);
    const [isShoppingcartMandatory, setIsShoppingcartMandatory] = (0, react_1.useState)(false);
    const [isFetching, setIsFetching] = (0, react_1.useState)(true);
    const [bookingNotice, setBookingNotice] = (0, react_1.useState)("");
    const [orderData, setOrderData] = (0, react_1.useState)(null);
    const { activeItem, currentLocale, userData, history, setItemsInCart, setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog, setShowShoppingCart, setIsOpen, clickFromCollapseBtn, setClickFromCollapseBtn, setImageIsHidden, orderCompleted, setOrderCompleted, disableStartTime, setShowVideo, } = props;
    const { token } = userData;
    const { isLoginRequired, loginUrl } = (0, useLogin_1.default)(userData);
    const { content } = props.activeItem;
    const { shoppingCartCatalogId } = content;
    const availabilityId = content.availability.id;
    const { kidsClubEnabled } = content.availability;
    if (kidsClubEnabled) {
        return (react_1.default.createElement(HandoverScreen_1.default, null));
    }
    const showProductDetail = (data) => {
        setProduct(data);
        setShowProduct(true);
    };
    const hideProductDetail = () => {
        setShowProduct(false);
    };
    const showShoppingMenu = () => {
        setShowProductCatalogForm(false);
        setShowProduct(false);
        setShowMenu(true);
    };
    const hideShoppingMenu = () => {
        setShowProductCatalogForm(true);
        setShowMenu(false);
    };
    const hideToast = () => {
        setToast("");
    };
    const closeShoppingCart = () => {
        history.goBack();
    };
    const showDiscardDialog = () => {
        if (orderData) {
            setShowDiscardShoppingCartDialog(true);
        }
        else {
            closeShoppingCart();
        }
    };
    const handleShoppingCartDiscard = (action = "") => {
        if (action === "confirm") {
            setItemsInCart(false);
            if (clickFromCollapseBtn) {
                setShowShoppingCart(false);
                setImageIsHidden(false);
                setShowVideo(true);
            }
            else {
                setIsOpen(false);
            }
            setClickFromCollapseBtn(false);
        }
        setShowDiscardShoppingCartDialog(false);
    };
    const reviewOrder = (basketItems, action = "add") => {
        if (basketItems.length < 1) {
            setOrderData(null);
            setBasket([]);
            if (action === "delete") {
                setToast(i18n_js_1.default.t("flash.item_deleted"));
            }
            return;
        }
        let order = "";
        basketItems.map((item) => {
            if (item.productId) {
                order = `${order}&order[line_items][][comment]=${item.comment}&order[line_items][][product_id]=${item.productId}&order[line_items][][quantity]=${item.quantity}`;
            }
            return item;
        });
        apiService_1.default.reviewShoppingCartOrder(currentLocale, token, shoppingCartCatalogId, order).then((orderReview) => {
            if (orderReview.status === "success") {
                setOrderData(orderReview);
                setItemsInCart(true);
                const basketItemsWithoutServiceFee = basketItems.filter((basketItem) => Object.hasOwnProperty.call(basketItem, "productId"));
                setBasket(basketItemsWithoutServiceFee);
                if (action === "add") {
                    setToast(i18n_js_1.default.t("item_added"));
                }
            }
            else {
                setError(orderReview.message);
            }
        });
    };
    const addToBasket = (items) => {
        reviewOrder([...basket, ...items]);
    };
    const deleteItemFromBasket = (itemIndex) => {
        const updatedBasket = basket.filter((basketItem, basketIndex) => basketIndex !== itemIndex);
        reviewOrder(updatedBasket, "delete");
    };
    const handleNavigationClick = () => {
        if (showProduct) {
            return hideProductDetail();
        }
        if (showMenu) {
            if (isShoppingcartMandatory) {
                history.goBack();
            }
            return hideShoppingMenu();
        }
        if (orderCompleted) {
            setShowProductCatalogForm(false);
            setOrderData(null);
            return closeShoppingCart();
        }
        return showDiscardDialog();
    };
    const renderShoppingCart = () => {
        if (error) {
            return (react_1.default.createElement(ErrorWrapper, null, error));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            showProduct && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "back-to-menu" },
                    react_1.default.createElement(material_1.IconButton, { size: "large", edge: "start", "data-testid": "back-button", className: "back-button", "aria-label": "back button", onClick: handleNavigationClick },
                        react_1.default.createElement(ArrowBack_1.default, null)),
                    react_1.default.createElement(material_1.Typography, { noWrap: true, component: "div", sx: { flexGrow: 1, display: { sm: "block" } }, className: "page-title" }, i18n_js_1.default.t("shopping_cart_back_to_menu"))),
                react_1.default.createElement(ProductDetail_1.default, { shoppingCartCatalogId: shoppingCartCatalogId, data: product, hideProduct: hideProductDetail, addToBasket: addToBasket }))),
            showMenu && !showProduct && (react_1.default.createElement(react_1.default.Fragment, null,
                bookingNotice !== "" &&
                    react_1.default.createElement(material_1.Box, { className: "booking-limits-notice" },
                        react_1.default.createElement(BookingLimitsErrorOrNotice_1.default, { bookingMessage: bookingNotice })),
                react_1.default.createElement(Menu_1.default, { orderData: orderData, shoppingCartCatalogId: shoppingCartCatalogId, showProduct: showProductDetail, hideMenu: hideShoppingMenu }))),
            orderCompleted && orderCompletedData && (react_1.default.createElement(OrderCompletedWrapper, null,
                orderCompletedData.texts.text && (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: orderCompletedData.texts.text,
                    } })),
                react_1.default.createElement(PermisisonWrapper, null,
                    react_1.default.createElement(NotificationPermissions_1.default, null)))),
            (showProductCatalogForm || (!isShoppingcartMandatory && !isFetching && !showMenu && !orderCompleted)) && (react_1.default.createElement(ProductCatalogForm_1.default, { deleteItemFromBasket: deleteItemFromBasket, orderData: orderData, shoppingCartCatalogId: shoppingCartCatalogId, availabilityId: availabilityId, showMenu: showShoppingMenu, contentType: content.type, reviewOrder: reviewOrder, setOrderCompleted: setOrderCompleted, setOrderCompletedData: setOrderCompletedData, setShowProductCatalogForm: setShowProductCatalogForm, setShowDiscardShoppingCartDialog: setShowDiscardShoppingCartDialog, setItemsInCart: setItemsInCart, activeItem: activeItem, disableStartTime: disableStartTime }))));
    };
    (0, react_1.useEffect)(() => {
        if (shoppingCartCatalogId) {
            apiService_1.default.getShoppingCartCatalog(props.currentLocale, token, shoppingCartCatalogId, content.availability.id).then((data) => {
                if (data.status === "success") {
                    const shoppingCartField = data.fields.find((field) => field.type === "shopping_cart");
                    if (shoppingCartField === null || shoppingCartField === void 0 ? void 0 : shoppingCartField.mandatory) {
                        setIsShoppingcartMandatory(true);
                        showShoppingMenu();
                    }
                    setIsFetching(false);
                }
                if (data.notice) {
                    setBookingNotice(data.notice.info);
                }
            });
        }
        else {
            setError("No shopping cart catalog id provided.");
        }
    }, []);
    if (isLoginRequired) {
        window.location.href = loginUrl;
        return (react_1.default.createElement(react_1.default.Fragment, null));
    }
    return (react_1.default.createElement(ShoppingCartWrapper, null,
        renderShoppingCart(),
        react_1.default.createElement(material_1.Snackbar, { onClose: hideToast, autoHideDuration: 4000, open: Boolean(toast), message: toast, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, className: "snackbar", action: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.IconButton, { size: "small", "aria-label": "close", color: "inherit" },
                    react_1.default.createElement(ShoppingCart_1.default, { fontSize: "small" })))) }),
        react_1.default.createElement(material_1.Dialog, { open: showDiscardShoppingCartDialog, TransitionComponent: Transition, keepMounted: true, onClose: () => handleShoppingCartDiscard(), "aria-describedby": "alert-dialog-slide-description", maxWidth: "xs" },
            react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t("discard_shopping_basket")),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => handleShoppingCartDiscard() }, i18n_js_1.default.t("cancel")),
                react_1.default.createElement(material_1.Button, { onClick: () => handleShoppingCartDiscard("confirm") }, "Ok")))));
};
exports.ShoppingCartRedesign = ShoppingCartRedesign;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
    baseUrl: store.getValue("baseUrl"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ShoppingCartRedesign));
